/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   searches bizo
 */

import { Bizo, autoclass } from '../../shared/bizos/base'

export const SavedSearch = autoclass('SavedSearch', class SavedSearch extends Bizo {}, {
  createdOn: 'created_on',
  device: 'device',
  email: 'email',
  emailFrequency: 'email_frequency',
  emailedOn: 'emailed_on',
  modifiedOn: 'modified_on',
  name: 'name',
  pushFrequency: 'push_frequency',
  pushedOn: 'pushed_on',
  searchId: 'search_id',
  sites: 'sites',
  query: 'query',
  userId: 'user_id',
  viewedOn: 'viewed_on',
})

export default {
  fromJS: (data) =>
    Array.isArray(data) ? data.map((d) => (d._data ? d : new SavedSearch(d))) : [],
}
